import { Users } from "lucide-react";

export default function ProductionCrew() {
  return (
    <div className="dm-page-container" style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", minHeight: "60vh", gap: 16,
      textAlign: "center", padding: "40px 20px"
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: 16,
        background: "rgba(6,182,212,0.1)",
        border: "1px solid rgba(6,182,212,0.2)",
        display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        <Users size={28} style={{ color: "#06B6D4" }} />
      </div>
      <h1 style={{
        fontFamily: "var(--font-orb)", fontSize: 20,
        color: "var(--t1)", letterSpacing: ".08em"
      }}>CREW DATABASE</h1>
      <p style={{
        fontFamily: "var(--font-mono)", fontSize: 13,
        color: "var(--t3)", letterSpacing: ".06em", maxWidth: 400
      }}>Coming Soon</p>
      <p style={{
        fontFamily: "var(--font-sans)", fontSize: 13,
        color: "var(--t4)", maxWidth: 400, lineHeight: 1.5
      }}>
        Crew profiles, availability tracking, and role-based assignment
        are being built. Stay tuned.
      </p>
    </div>
  );
}
